module.exports = "/assets/e87c5e7ce9e33cb938ed672aea0de6ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/VA.png
// module id = 1919
// module chunks = 0